<ion-grid class="course-schedule {{class}}" *transloco="let t; prefix: 'courseScheduleComp'"
          [ngClass]="{'past-course': isPast}">
    <ion-row class="ion-align-items-start title">
        <ion-col size="12">
<!--            {{ group.title | transloco }}-->
            {{ group.title }}
        </ion-col>
    </ion-row>

    <div class="content">
        <ion-row class="ion-no-padding ion-no-margin">
            <ion-col size="12">

                <div *ngFor="let exam of group.exams">
                    <app-lesson-test *ngIf="isCurrent && exam?.triesLeft!=0" [exam]="exam"  [withMarginBottom]="true"></app-lesson-test>
                </div>

                <app-next-lesson [class]="class"
                                 [lessonStart]="lessonStart"
                                 [isFuture]="isFuture"
                                 [isPast]="isPast"
                                 [isCurrent]='isCurrent'
                                 [data]="group.nextLessonData"
                                 [hideButton] = "hideEducationMaterials"
                ></app-next-lesson>

                <ion-row class="ion-no-padding ion-no-margin lesson-info" *ngIf="group.typeCourse != GROUP_TYPE_CAMP">

                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-lesson-materials [class]="class"
                                              [isFuture]="isFuture"
                                              [isPast]="isPast"
                                              [isCurrent]='isCurrent'
                                              [data]="group.nextLessonProgress"
                                              [hideEducationMaterials] ="hideEducationMaterials || !group.educationalMaterialId || group.hideEducationMaterial"
                                              [groupId]="group.id"
                                              [animated]="!!group.nextLessonData?.isAnimated"
                        ></app-lesson-materials>

                    </ion-col>
                    <ion-col size="3" size-md="3" size-sm="12" size-xs="12" class="ion-no-padding ion-no-margin">

                        <app-all-materials [class]="class"
                                           [hideEducationMaterials]="hideEducationMaterials || !group.educationalMaterialId || group.hideEducationMaterial"
                                           [groupId]="group.id"
                                           [fileAccess]="group.haveEducationMaterialFileAccess"
                                           [files]="group.educationMaterialFiles"
                        ></app-all-materials>

                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>


    </div>

</ion-grid>
